import { injectAsyncReducer, injectAsyncSaga } from '../../../utils';
import { initLoadManagerActionSaga } from '../../../root-modules/init-load-manager-module';
export var runInjectorConfig = function (_a) {
    var store = _a.store, storeInjectConfig = _a.storeInjectConfig, _b = _a.storeInjectConfig, _c = _b === void 0 ? {} : _b, additionalConfig = _c.additionalConfig, reducersToInject = _c.reducersToInject, sagasToInject = _c.sagasToInject, initialLoadManagerConfig = _c.initialLoadManagerConfig;
    if (!storeInjectConfig) {
        return;
    }
    // inject reducers
    if (reducersToInject) {
        reducersToInject.forEach(function (_a) {
            var reducer = _a.reducer, name = _a.name, isRoot = _a.isRoot;
            injectAsyncReducer({
                store: store,
                name: name,
                reducer: reducer,
                isRoot: isRoot,
            });
        });
    }
    // inject sagas
    if (sagasToInject) {
        sagasToInject.forEach(function (_a) {
            var saga = _a.saga, name = _a.name, isRoot = _a.isRoot;
            return injectAsyncSaga({
                store: store,
                name: name,
                saga: saga,
                isRoot: isRoot,
            });
        });
    }
    // call an action before to call initialLoadManagerConfig
    if (additionalConfig && additionalConfig.callbackBeforeInject) {
        additionalConfig.callbackBeforeInject(store.dispatch);
    }
    // dispatch initial load requests
    if (initialLoadManagerConfig) {
        store.dispatch(initLoadManagerActionSaga(initialLoadManagerConfig));
    }
    // call an action on mount page
    if (additionalConfig && additionalConfig.callbackOnMount) {
        additionalConfig.callbackOnMount(store.dispatch);
    }
};
